<div class="d-flex justify-content-end align-items-center">
  <mat-icon fontSet="material-symbols-outlined" class="pointer text-white" mat-dialog-close>close</mat-icon>
</div>
<iframe [src]="url" allow="autoplay"></iframe>
